<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <el-form :inline="true" ref="form" :model="form" label-width="80px">
      <el-form-item label="角色名称">
        <el-select clearable v-model="form.name" placeholder="请选择角色">
          <el-option
            v-for="(v, i) in roleNameArr"
            :key="i"
            :label="v.name"
            :value="v.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="form.startTime"
          format="yyyy-MM-dd"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        至
        <el-date-picker
          v-model="form.endTime"
          :picker-options="pickerOptionsEnd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList()">查询</el-button>
        <el-button
          @click="
            form = { startTime: '', endTime: '' };
            getList();
          "
          >重置</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 按钮 -->
    <btns class="mgb-20" @exec="exec"></btns>
    <!-- 表格 -->
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="name" label="角色名称"> </el-table-column>
      <el-table-column prop="status" label="启用状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.status === 1
                ? '启用'
                : scope.row.status === 0
                ? '禁用'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
          <el-button type="text" size="small" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" size="small" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";

export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {},
      tableData: [],
      roleNameArr: [],
    };
  },
  created() {
    this.getList();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  methods: {
    getList() {
      this.$api.staff
        .staffRoleList({
          name: this.form.name,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data;
            this.getRolePull();
          }
        });
    },
    handleDel(row) {
      // if (row.status === 1) {
      //   handleAlert("该角色已启用,无法删除", "error");
      //   return;
      // }
      handleConfirm("确认删除该角色吗?", "info")
        .then(() => {
          this.$api.staff.staffRoleDel({ id: row.id }).then((res) => {
            if (res.code === 200) {
              handleAlert("角色已删除", "success");
              this.getList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    // 角色下拉
    getRolePull() {
      this.$api.staff.staffRolePull().then((res) => {
        if (res.code === 200) {
          this.roleNameArr = res.data;
        }
      });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 新增角色
    add() {
      this.$router.push({
        path: "/staff/staffRole/setRole",
      });
    },
    handleEdit(row) {
      this.$router.push({
        path: "/staff/staffRole/setRole",
        query: {
          id: row.id,
        },
      });
    },
    handleDetail(row) {
      this.$router.push({
        path: "/staff/staffRole/setRole",
        query: {
          id: row.id,
          isDetail: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
